import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { format, fromUnixTime, getUnixTime } from 'date-fns';

import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import RetailPage from 'src/containers/Page/RetailPage';
import './RetailReprint.scss';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { RootState } from 'src/configs/store';
import { formatAmountToFixed } from 'src/utils/utils';
import Button from 'src/components/Button/Button';
import ModalContainer from '../CancelTicket/components/ModalContainer/ModalContainer';
import Icon from 'src/components/Icon/Icon';

function RetailReprint() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [lastTickets, setLastTickets] = useState(null);
  const [reprintCode, setReprintCode]= useState('');
  const [pin, setPin]= useState('');
  const [isModalOpen, setisModalOpen]= useState(false);

  const { selectedTimezone } = useSelector((state: RootState) => state.odds);

  const allowAnyReprint = useSelector((state: RootState) => {
    return !(state.peripherals?.reprintTickets && state.peripherals.reprintAnyTicket) && localStorage.getItem('fakeTill') !== 'true';
  });

  const allowSessionReprint = useSelector((state: RootState) => {
    return !(state.peripherals?.reprintTickets && state.peripherals.reprintAnyTicketFromSession) && localStorage.getItem('fakeTill') !== 'true';
  });


  const loadLastTickets = async () => {
    const date = getUnixTime(+localStorage.getItem('firstLogin') * 1000);
    const tickets = await dispatch.peripherals.getLastTickets(date);
    setLastTickets(tickets);
  };

  const reprintTicketRequest = async () => {
    const clear = await dispatch.peripherals.ticketReprint({ ticketId: reprintCode, pin: pin === '' ? '-1' : pin });
    if (clear){
      setPin('');
      setReprintCode('');
    }
    setisModalOpen(false);
  };

  const onClickReprint = (code) => {
    setReprintCode(code);
    setisModalOpen(true);
  };

  const onSubmitReprint = (e) => {
    e.preventDefault();
    onClickReprint(reprintCode);
  };

  useEffect(() => {
    loadLastTickets();
  }, []);

  return (
    <RetailPage includeBetslip={ false }>
      <BreadCrumb
        breadcrumbs={
          [
            { name: t('omr.home'), link: '/' },
            { name: t('retail.reprintTicket'), link: '' }
          ]
        }
      />
      <div className="reprint">
        <form
          className="reprint__form"
          onSubmit={ onSubmitReprint }
        >
          <label className="reprint__label">Ticket:</label>
          <input
            value={ reprintCode }
            className="reprint__input"
            type="text"
            autoComplete="new-password"
            disabled={ allowAnyReprint }
            onChange={ (e) => setReprintCode(e.target.value) }
            required
          />
          <label className="reprint__label">Pin:</label>
          <input
            value={ pin }
            className="reprint__input"
            type="text"
            autoComplete="new-password"
            disabled={ allowAnyReprint }
            onChange={ (e) => setPin(e.target.value) }
            minLength={ 4 }
            required
          />
          <button
            className="code-search__button"
            disabled={ allowAnyReprint }
          >
            <Icon
              icon="return"
              className="code-search__check"
            />
          </button>
        </form>
        <div className="reprint__container">
          <div className="reprint__header">
            <div className="reprint__header--child">{ t('retail.code') }</div>
            <div className="reprint__header--child">{ t('retail.date') }</div>
            <div className="reprint__header--child">{ t('retail.time') }</div>
            <div className="reprint__header--child">{ t('retail.totalStake') }</div>
          </div>
          {
            _.map(lastTickets, (ticket) => {
              if (_.size(ticket) > 0){
                const date = format(utcToZonedTime(fromUnixTime(ticket.registerDate), selectedTimezone), 'dd/MM/yyyy');
                const time = format(utcToZonedTime(fromUnixTime(ticket.registerDate), selectedTimezone), 'HH:mm:ss');
                return (
                  <div key={ ticket.id } className="reprint__tickets">
                    <div>{ ticket.code }</div>
                    <div>{ date }</div>
                    <div>{ time }</div>
                    <div>{ formatAmountToFixed(ticket.totalStake, ticket.divisor) }</div>
                    <Button
                      className="btn--primary reprint__btn retail-home__button--revert-color"
                      size="medium"
                      disabled={ allowSessionReprint }
                      name="test-omr"
                      onClick={ () => onClickReprint(ticket.code) }
                      text={ t('retail.print') }
                    />
                  </div>
                );
              } else {
                return null;
              }
            })
          }
        </div>
      </div>
      {
        isModalOpen &&
        <ModalContainer onClose={ () => { setReprintCode(''); setPin(''); } } >
          <ModalContainer.Reprint
            code={ reprintCode }
            onSubmit={ reprintTicketRequest }
            onClose={ () => setisModalOpen(false) }
          />
        </ModalContainer>
      }
    </RetailPage>
  );
}

export default RetailReprint;
